/**
 * Descobre qual cliente da plataforma está sendo acessado.
 * sola.dotapps.com.br → "sola". Em localhost/pages.dev usa ?cliente=dot (fica salvo) ou VITE_DEFAULT_TENANT.
 */
const ROOT = (import.meta.env.VITE_ROOT_DOMAIN || 'dotapps.com.br').toLowerCase();

export function resolveTenantSlug(): string {
  const host = location.hostname.toLowerCase();
  if (host.endsWith(`.${ROOT}`)) {
    const sub = host
      .slice(0, -(ROOT.length + 1))
      .split('.')
      .pop();
    if (sub && !['www', 'app', 'api'].includes(sub)) return sub;
  }
  const fromUrl = new URLSearchParams(location.search).get('cliente');
  try {
    if (fromUrl) sessionStorage.setItem('dotapps-tenant', fromUrl);
    const saved = sessionStorage.getItem('dotapps-tenant');
    if (saved) return saved;
  } catch {
    /* navegação privada */
  }
  return import.meta.env.VITE_DEFAULT_TENANT || 'sola';
}

export const TENANT_SLUG = resolveTenantSlug();
